{
  "categories": [
    "Game",
    "Website",
    "Seed Generator",
    "Logic",
    "Bingo",
    "Multiplayer",
    "Misc"
  ],
  "releases": [
      {
        "version": "4.2.17.2",
        "date": "2026-08-28",
        "announce": "all",
        "title": "Rando App Release",
        "changes": [
          {
            "text": "The Ori Rando App, built by :AsmPrgmC3, is now generally available as a launcher, updater, and general utility program for the Ori DE Randomizer!",
            "category": "Misc",
            "type": "feature",
            "importance": "major",
            "sub": [
              "It installs the randomizer for you, keeps it updated, and can switch between rando versions and vanilla as required.",
              "(Getting into Ori Rando has never been easier! Tell your friends.)",
              "It allows you to play seeds via the new Play button on seed pages.",
              "You can also play seeds by dragging & dropping them onto the app.",
              "It automatically archives your old seeds and your stats.txt.",
              "It can find and open your various settings and configuration files for you.",
              "Find it in the Downloads section of the main menu above."
            ]
          },
          {
            "text": "Seed pages now have a Play button, which launches the game via the Rando App and sends your seeds directly to it.",
            "category": "Website",
            "type": "feature",
            "importance": "major",
            "sub": [
              "The Play button will confuse your browser if you click it and do not have the Rando App installed.",
              "Downloading seeds via the download button still works exactly the way it always has."
            ]
          },
          {
            "text": "Updated FAQ and help texts to recommend the Rando App to users.",
            "category": "Website",
            "importance": "minor"
          }
        ]
      },
      {
        "version": "4.2.17.1",
        "date": "2026-08-22",
        "announce": "all",
        "changes": [
          {
            "text": "Bingo boards now take your spawn location into account.",
            "category": "Bingo",
            "type": "feature",
            "importance": "major",
            "sub": [
              "Discovery boards pick their starting squares based on where you spawned.",
              "You should no longer get squares that are automatically completed due to your spawn teleporter or location."
            ]
          },
          {
            "text": "Some journeys between spirit wells now only appear on hard boards.",
            "category": "Bingo",
            "importance": "major",
            "sub": [
              "From Lost Grove to anywhere; to Lost Grove from anywhere but Blackroot, Glades, Grotto, and Swamp.",
              "Anything between two dungeons, and Sorrow to Ginso.",
              "Anything to or from the Grove well (don't skip the Grove cutscene with a hard board!)"
            ]
          },
          {
            "text": "Boards now roll at most three Collect Pickups In squares.",
            "category": "Bingo",
            "importance": "minor"
          }
        ]
      },
      {
        "version": "4.2.17",
        "date": "2026-08-20",
        "announce": "dev",
        "changes": [
          {
            "text": "Added beta support for the launcher app.",
            "category": "Misc",
            "type": "feature",
            "importance": "major"
          }
        ]
      },
      {
      "version": "4.2.16.1",
      "date": "2026-08-19",
      "announce": "all",
      "changes": [
        {
          "text": "Bingo boards built from a seed have a Reroll Seed button, which rolls a new rando seed using the current seed's settings and then opens the bingo creation page for that new seed.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "The owner of a bingo game can now reroll the bingo board if no players have joined the bingo lobby.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Added a system to publish site-only patch notes for site changes without matching dll updates (like the one you're currently reading).",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Opening a link to a patch note with only minor changes now shows all minor changes automatically.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Links to a patch note scroll to the right one.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.2.16",
      "date": "2026-08-18",
      "announce": "dev",
      "changes": [
        {
          "text": "Fixed a bug making the version number very large after quitting to menu.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.2.15",
      "date": "2026-08-18",
      "announce": "all",
      "changes": [
        {
          "text": "It's now possible to update your randomizer in-game! Select \"Update to $(Version)\" from the main menu to download and then apply the latest update.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "The option only appears when there's a new version to update to."
          ]
        },
        {
          "text": "The .dat seed file format is now versioned, and the DLL knows which seed format versions it's compatible with.",
          "category": "Misc",
          "type": "feature",
          "importance": "major",
          "sub": [
            "The game will print an error if it can't read the currently-loaded seed and explain how to fix it.",
            "As a result of this change, clients earlier than 4.2.9 will not be able to parse new seeds from the website."
          ]
        },
        {
          "text": "The title screen says Randomizer under the logo!",
          "category": "Game",
          "importance": "major"
        },
        {
          "text": "Your version number shows in the corner of the main menu and the pause screen.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.2.14",
      "date": "2026-08-15",
      "announce": "dev",
      "changes": [
        {
          "text": "Message pickups can style their text with <style> tags: color, font, size and letter spacing, and <icon> for button prompts.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Styles nest, so a part of a message can differ from the rest."
          ]
        },
        {
          "text": "Everything message pickups can do is written up in SH Format.txt, next to the other reference files.",
          "category": "Game",
          "importance": "minor",
          "sub": [
            "Includes box formatting prefixes, placeholders, colors, styles, and which characters each font actually has."
          ]
        },
        {
          "text": "Multi-pickups can hold items with slashes in them, like message pickups.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Older randomizers read these wrong, so update before loading a seed that uses one.",
            "Hand-editing a seed file: slashes inside an MU or RP pickup have to be doubled."
          ]
        },
        {
          "text": "Tabs you aren't looking at update every 30 seconds instead of every second, and refresh as soon as you come back.",
          "category": "Website",
          "importance": "minor",
          "sub": [
            "OBS browser sources count as visible, so stream overlays keep updating normally."
          ]
        },
        {
          "text": "The tracking map names items the way the game does: yours plain, everyone else's with their name.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed Archipelago yaml downloads failing for some spawns and for custom item pools.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "A room with nobody playing disconnects after a few hours, and reconnects when someone starts again.",
          "category": "Multiplayer",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        }
      ]
    },
    {
      "version": "4.2.13",
      "date": "2026-08-14",
      "announce": "dev",
      "changes": [
        {
          "text": "Receiving up to five items at once prints them one by one instead of summarizing.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Alt+T still holds the last five either way."
          ]
        },
        {
          "text": "Added the Mark bonus skill, which prints your position, scene and zone.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plandos can hand out a pickup that turns on the game's debug movement controls.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The Alt+Rs Used stat shows your actual Alt+R count again.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Staying logged in now lasts a year, and logging out actually logs you out.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "The game tracker no longer re-requests a seed forever when a player's seed is empty.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added six new Die To bingo goals.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Valley Map Baneling, R1 Door Baneling, Swamp Swim Crushers, Grotto Vault Lasers, Spidersack Spikes and Valley Floor Frogs."
          ]
        },
        {
          "text": "Deaths to crushers now count for Die To goals however the crusher kills you.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Valley of the Wind teleporter goal no longer turns up twice as often as the others.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Lots of Archipelago fixes.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Items that could not be delivered are listed on the seed tab.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "The room refuses to connect while a player is on a randomizer older than the bridge supports.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "The tracking map shows real item names instead of AP Item #1.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Spoilers and item lists show where things really ended up, not the pre-export roll.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Keysanity door clues say Hint loading instead of naming the wrong zone.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "The seed download waits until every world's item names are ready.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ],
          "sub": [
            "There is a download anyway link if you would rather have generic names."
          ]
        },
        {
          "text": "AP shadow players no longer show up in the tracking map, history, or similar.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ],
          "sub": [
            "Q: Eiko, what even are AP shadow players? Why do they exist? Should I be scared?",
            "A: Don't even worry about it."
          ]
        }
      ]
    },
    {
      "version": "4.2.12",
      "date": "2026-08-12",
      "changes": [
        {
          "text": "Patch notes are now on the site, covering every release back to 3.0.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Finding one of your own items grants the right copy, and it comes back after a death or a quit to menu.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Quitting to menu can no longer be used to claim extra copies of your own items.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        }
      ]
    },
    {
      "version": "4.2.11",
      "date": "2026-08-12",
      "changes": [
        {
          "text": "Added Mini Health and Mini Energy.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Each restores you to full and then grants one temporary health or energy."
          ]
        },
        {
          "text": "Temporary health and energy now have their own row above each bar.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Disable Temporary Resource Rows brings back the old inline display.",
            "Temp Row Spacing, Temp Row Horizontal Offset, Temp Row Scale and Temp Row Brightness adjust the rows."
          ]
        },
        {
          "text": "Temporary health and energy you start the seed with are no longer wiped at spawn.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed your own duplicated items sometimes being granted twice.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        }
      ]
    },
    {
      "version": "4.2.10",
      "date": "2026-08-12",
      "changes": [
        {
          "text": "Plants now use their own icon on the in-game map.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Keystone door warnings no longer fire at doors that are in logic.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Doors you cannot afford yet stay quiet.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Pickup messages stay on screen for the same time with VSync on.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Using an empty bonus skill slot now tells you the slot is empty.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed a second copy of one of your own items not being granted.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        }
      ]
    },
    {
      "version": "4.2.9",
      "date": "2026-08-10",
      "changes": [
        {
          "text": "Keystone doors warn you before you open one that is not in logic.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Turn it off with Keystone Door Logic Warnings in RandomizerSettings.txt."
          ]
        },
        {
          "text": "The site follows your browser's light or dark preference until you pick a theme.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Hints in the guides are now click-to-reveal.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Rolling an Archipelago bingo game leaves you on the Seed tab so you can grab the apworld and YAML first.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Bingo boards can now be a single world.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Shared starting items now go to every player.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major",
          "tags": [
            "Multiworld"
          ]
        },
        {
          "text": "Export Stones now puts regular Keystones into the Archipelago pool.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ],
          "sub": [
            "Each keystone door comes into logic once your total keystone count reaches its threshold."
          ]
        },
        {
          "text": "DeathLink no longer sends the same death twice.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        }
      ]
    },
    {
      "version": "4.2.8",
      "date": "2026-08-06",
      "changes": [
        {
          "text": "Charge Jump is back to its normal strength.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Seed rows now have both a View Spoiler and a Save Spoiler button.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The setup panel now hands out one YAML file for the whole game.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "The host box comes prefilled with archipelago.gg.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "The Advanced tab replaces the Starved variations with Buried placement buttons.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "The Starved flags still work from the command line generator."
          ]
        },
        {
          "text": "Fixed Multiworld seeds failing to generate with certain custom item pools.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Items that remove an upgrade now show a readable name instead of an item code.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added Bingo support.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Multiplayer and Archipelago seeds can be rolled with a name for each player.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Your own items are granted the moment you pick them up.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Fixed items being lost when a warning message arrived at the same time.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        }
      ]
    },
    {
      "version": "4.2.7",
      "date": "2026-08-05",
      "changes": [
        {
          "text": "AsmPrgmC3 is credited under major contributions.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "The spoiler button's cog has a View/Download setting, replacing the separate Save Spoiler button.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The seed tab walks you through Archipelago setup, with a button to download the apworld.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Item pools and forced placements can take a \"one of...\" group, which rolls one of the listed items.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "The Extra Bonus and Bonus Lite pools roll a different mix of jump and velocity upgrades every seed.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Bingo and Archipelago don't mix yet.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Balance Bias now keeps each world's first unlocks inside that world.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major",
          "tags": [
            "Multiworld"
          ]
        },
        {
          "text": "Archipelago can be turned on for any seed, including single-player ones.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Items bound for other games show their real names, like \"Progressive Sword (Zelda)\".",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ],
          "sub": [
            "Connect the room before handing out seeds; a seed downloaded first shows \"AP Item #n\" instead."
          ]
        },
        {
          "text": "Added Death Link.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ],
          "sub": [
            "It's set when the seed is rolled and can't be changed later."
          ]
        },
        {
          "text": "Key clues and Stomp/Grenade hints name the real Archipelago location once they unlock.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "The Seed tab reports when Archipelago item names are ready.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ],
          "sub": [
            "A seed downloaded before the room is connected names every Archipelago location 'AP Item #1' and so on until you download it again."
          ]
        },
        {
          "text": "Items arriving from another world name the player who sent them.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "A big release arrives as one message instead of dozens.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Spirit Light grants the exact amount the seed placed instead of rounding.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        },
        {
          "text": "Connecting to a room that can't be reached fails right away instead of sitting on Pending.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ]
        }
      ]
    },
    {
      "version": "4.2.6",
      "date": "2026-08-02",
      "changes": [
        {
          "text": "Archipelago games get a per-world YAML download and a room panel on the Seed tab.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ],
          "sub": [
            "The room panel connects to your Archipelago room and shows each world's item count and goal."
          ]
        },
        {
          "text": "Multiworld seeds no longer split the Spirit Light pool between worlds.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed multiworld items you had already been given disappearing from your inventory.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Finishing your game no longer strands your world's remaining multiworld items.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Multiworld games can now join an Archipelago session.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Archipelago"
          ],
          "sub": [
            "Choose which categories go into the shared pool on the Multiplayer tab: skills, teleporters, world events, cells, and stones."
          ]
        }
      ]
    },
    {
      "version": "4.2.5",
      "date": "2026-07-30",
      "changes": [
        {
          "text": "Added Door Hint pickups, which reveal a keysanity door's hints without walking to the door.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added Buried placements: an item placed at Buried050, 100, 150, or 200 is held back until that many locations are reachable.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Pick a Buried location in the placement rows on the Advanced tab, or use the Walls, Grenade, and Teleporters buttons for the usual sets."
          ]
        },
        {
          "text": "The Advanced tab has Walls, Grenade and Teleporters buttons that fill in Buried placements for you.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.2.4",
      "date": "2026-07-29",
      "changes": [
        {
          "text": "Reloading your seed with Alt+L now retries a dropped connection to the site.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Items and messages from other players now show up the moment they are sent.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        }
      ]
    },
    {
      "version": "4.2.3",
      "date": "2026-07-27",
      "changes": [
        {
          "text": "Removed two impossible logic paths, in Horu L4 (expert) and at the Sorrow teleporter (master).",
          "category": "Logic",
          "type": "fix",
          "importance": "major"
        }
      ]
    },
    {
      "version": "4.2.2",
      "date": "2026-07-26",
      "changes": [
        {
          "text": "Seeds with fewer than two flags in the header now load correctly.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "The win message is no longer eaten if you die at the moment you win.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Bingo boards can now roll Journey goals.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Travel between the two named spirit wells without touching another well or teleporting.",
            "The square shows as in progress while you stand at the starting well."
          ]
        },
        {
          "text": "Experience sent to you from another world uses its random name again.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.2.1",
      "date": "2026-07-25",
      "changes": [
        {
          "text": "Custom pickup messages with a set duration now disappear on time.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Custom pickup messages with a set background color now use it.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed some site pages failing to load in an OBS browser source.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added a guide for the bingo userboard, linked from the bingo page.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major"
        }
      ]
    },
    {
      "version": "4.2.0",
      "date": "2026-07-25",
      "changes": [
        {
          "text": "Pickup message backgrounds are configurable, and items you find for another player get their own color.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Relevant settings: Pickup Message Background Color and Multiworld Outbound Message Background Color in RandomizerSettings.txt.",
            "Outbound messages are gray by default."
          ]
        },
        {
          "text": "Keysanity door hints no longer pile up in the message queue.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Multiworld is the default multiplayer game type in the seed builder.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Co-op always uses Cloned Seeds, and the Seed Generation Mode dropdown is gone.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The preplacement world picker is a dropdown, so it still fits with a lot of players.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed the tracker map failing to load for some games.",
          "category": "Website",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Hovering a multiplayer game type shows help for that mode, and the help box no longer jumps around under your cursor.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Preplacement works in multiworld seeds: pick which player's world the location is in and which player the item belongs to.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Multiworld keeps its own Shared Item Categories selection, separate from Co-op's, and starts with nothing shared.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Multiworld shared categories leave out Misc: trees, World Tour relics and Keysanity keys always stay per-world.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The two bingo symmetry goals had their names swapped.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major",
          "sub": [
            "A horizontally symmetric board matches columns A/B against D/E; a vertically symmetric one matches rows 1/2 against 4/5."
          ]
        },
        {
          "text": "Winning a bingo game announces the win right away instead of waiting for you to press alt+L.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Finding an item for another player names them and colors the item.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.10",
      "date": "2026-07-23",
      "changes": [
        {
          "text": "Holding alt+T shows your last five messages even with the side message queue turned off.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Setting Hints to Disabled now also turns off the Fronkey tip and the wall jump tree hint.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Experienced hint level now shows its own loading screen tips.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Always Show Last Five Pickup Messages only does anything with the side message queue turned on.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The seed builder has help text for Multiworld.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Shared Item Categories now work in Multiworld: a shared category exists once across every world, and whoever finds it grants it to everyone.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Skills, Teleporters, Upgrades and World Events can each be shared."
          ]
        },
        {
          "text": "Added a Multiworld Balance Bias setting for how evenly progression is spread between worlds.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "0.0 (the default) ignores balance, 1.0 keeps every world supplied with reachable checks. Try 0.5."
          ]
        },
        {
          "text": "Multiworld seeds say preplacement is not supported instead of failing to generate.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.9",
      "date": "2026-07-23",
      "changes": [
        {
          "text": "Warping to the credits now counts as finishing the game and records your run in the stats screen.",
          "category": "Game",
          "type": "fix",
          "importance": "minor",
          "sub": [
            "In multiworld this also releases what is left in your world."
          ]
        },
        {
          "text": "Keysanity door hints point at keys that are in other players' worlds.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Pickup messages, clues and hints use other players' names once they have joined.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Multiworld"
          ]
        },
        {
          "text": "Grouped item messages color their items and count shards and fragments.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Multiworld"
          ]
        },
        {
          "text": "Items you receive while the credits are rolling arrive quietly.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "tags": [
            "Multiworld"
          ]
        }
      ]
    },
    {
      "version": "4.1.8",
      "date": "2026-07-23",
      "title": "Multiworld",
      "headline": "Multiworld is here. Everyone gets their own world, and everyone's items are shuffled across all of them: what you find might belong to someone else, and someone else is out there finding yours.",
      "changes": [
        {
          "text": "The plando editor can set entrance shuffle door connections.",
          "category": "Website",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Links are two-way by default, with one-way links and arbitrary warp targets also available.",
            "Connections are per player, so each world in a multiplayer plando can have its own layout."
          ]
        },
        {
          "text": "Plando multipickup entries can be clicked to edit in place and dragged to reorder.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The plando editor's flag list now offers every seed variation and key mode.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "R1 Outer can only be connected to R1 Inner.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plando entrance shuffle can point a door at arbitrary map coordinates as a one-way warp target.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plando entrance connections are stored per player, so each world in a multiplayer plando can have its own door layout.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed multiplayer plandos serving player 1's seed to everyone.",
          "category": "Website",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "The site now shows why a seed failed to generate instead of a generic error.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Half-typed text in the plando pickup box is no longer wiped when the box loses focus.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Clicking an empty location in the plando editor no longer creates a placement there, and clearing a location's pickup removes it.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The plando clue order now recognizes dungeon keys inside a multipickup.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Plando logic and reachability now follow the player you have selected.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the Shards Race option in the plando editor's multiplayer controls.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Importing a tracked seed into the plando editor no longer adds its sync header to the flag list.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "SplitShards and Seperate Seeds have been removed.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Use Multiworld with the Shards key mode, or Cloned Seeds."
          ]
        },
        {
          "text": "Plandos can place a Random Relic or a Random Warp, including inside multipickups.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed bingo squares flickering between complete and incomplete.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed the Start Game button vanishing for the player who made the bingo game.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Bingo players joining, leaving and starting a game show up right away.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The bingo keystone door goal picks its target counts based on whether the seed is open world.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed a missing line break in the bingo keystone door goal's help text, and the help link being hard to see on completed cards.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added Multiworld.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Multiworld requires tracking, and each player downloads their own seed."
          ]
        },
        {
          "text": "Finishing your game releases the items still sitting in your world to the players who own them.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major",
          "tags": [
            "Multiworld"
          ]
        },
        {
          "text": "Pickups name the player they belong to, both when you find one and when you receive one.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Multiworld"
          ]
        },
        {
          "text": "Receiving several items at once shows one grouped message instead of one per item.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "tags": [
            "Multiworld"
          ]
        },
        {
          "text": "Dungeon key clues point at keys that are in other players' worlds.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The game now warns you if your loaded seed belongs to a different game, or to another player.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.7",
      "date": "2026-07-19",
      "changes": [
        {
          "text": "You can now edit the pool of random Experience names.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Edit ExpNames.txt in your game folder, one name per line.",
            "Needs Randomized Experience Names turned on."
          ]
        },
        {
          "text": "The plando list no longer breaks on seeds from deleted accounts.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The item tracker no longer errors out for a player who has not picked anything up.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed Valley damage boost paths that asked for too little health.",
          "category": "Logic",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added a route from the right side of Valley back to the Valley teleporter.",
          "category": "Logic",
          "importance": "major"
        },
        {
          "text": "Added air dash paths through Valley.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Fixed Bingo boards freezing and never updating again.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed Bingo squares counting twice when two players marked one at the same moment.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed messages from the site, like race placements, not arriving in game.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Resetting a game and handing it to another player works again.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Credited jmal116 for the custom experience names.",
          "category": "Misc",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.6",
      "date": "2025-08-28",
      "changes": [
        {
          "text": "Fixed logic updates not reaching the in-game map.",
          "category": "Logic",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed Bingo boards not updating in game.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Bingo updates and the logic map's area data were still using the old address, and now follow the new one.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major",
          "sub": [
            "The site requires 4.1.6 or newer as a result."
          ]
        }
      ]
    },
    {
      "version": "4.1.5",
      "date": "2025-08-28",
      "title": "Sign in with Google",
      "headline": "Logging in to orirando.com now goes through Google. The first time you sign in, your name, plandos, games and bingo boards come with you.",
      "changes": [
        {
          "text": "Seed loading errors now name the line of randomizer.dat that failed.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plandos can now take Skill Velocity Upgrades and Jump Upgrades below zero.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "orirando.com now uses Google sign-in.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Plando pages now say who to contact about missing seeds.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "A plando author's seeds are now listed alphabetically.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plando lists no longer drop seeds by authors who have not signed in yet.",
          "category": "Website",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Logging in or out returns you to the page you were on.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The randomizer now connects to the site at a new address, so 4.1.4 and older dlls can't reach it any more.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Sync updates no longer slow down at low framerates.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.4",
      "date": "2025-08-01",
      "changes": [
        {
          "text": "Keysanity door hints can now stay on the map instead of only showing when you hover a door.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Relevant setting: Always Show Keysanity Door Hints in RandomizerSettings.txt."
          ]
        },
        {
          "text": "Door hints now say when a door is already open.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Map tooltips scale with how far you are zoomed in.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed garbled setting descriptions in RandomizerSettings.txt.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Tidied up the keysanity hint and progress text.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Misc menu now links to the Ori Rando League rules and the trick glossary.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed the game tracker map bogging down.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the logic helper ignoring a starting inventory passed in the URL.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.3",
      "date": "2025-04-17",
      "changes": [
        {
          "text": "Sense no longer stays stuck on the last pickup once you have collected everything it can find.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Enhanced Charge Jump only explodes what actually dies.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Collecting a door's last keystone no longer prints an empty list of remaining areas.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Last 10 Games list shows your ten most recent games.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Tidied up the Legacy Flags row on the seed generator's Advanced tab.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Rerolling a seed no longer breaks forced item placements, random spawn, or free keys.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Keysanity with Open World no longer puts Glades pool keystones in the item pool.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Entrance Shuffle no longer leaves the Horu escape door's vanilla connection in place.",
          "category": "Logic",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Entrance Shuffle pairs its doors with a new algorithm.",
          "category": "Logic",
          "importance": "major"
        },
        {
          "text": "In Entrance Shuffle, dungeon keys only open their own door and no longer gate the pickups inside.",
          "category": "Logic",
          "importance": "major",
          "sub": [
            "The Keys Only For Doors flag is gone -- Entrance Shuffle always does this now."
          ]
        },
        {
          "text": "Discovery bingo boards can roll Activate Squares.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Discovery bingo boards no longer fail to generate when a symmetry square rolls.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Bonus skills and ability upgrades your teammates find are no longer granted to you over and over.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "The Glades teleporter shares with your teammates.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.2",
      "date": "2025-04-04",
      "changes": [
        {
          "text": "Picking up a Keysanity keystone lists the areas that still hold the rest of that door's keystones.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "You get this once you've visited the door.",
            "Areas holding more than one show a count."
          ]
        },
        {
          "text": "Horizontal dashes no longer drag you downward.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Enhanced Stomp no longer stops on glancing hits, and stomping sideways into a wall works again.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Aiming an Enhanced Dash upward off the ground registers reliably.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Enhanced Spirit Flame brings Sein's dialogue with it, even in seeds that aren't Enhanced.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Enhanced help text describes the variation.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Seed contents name Enhanced skills properly and no longer break on unrecognized items.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The April Fools event has ended, so Enhanced and meta bingo squares are no longer on by default.",
          "category": "Seed Generator",
          "importance": "major",
          "sub": [
            "The Randomize! button also picks Enhanced, Keysanity and Entrance Shuffle less often now."
          ]
        },
        {
          "text": "Share Misc now also covers Keysanity zone keys, and Enhanced bonus upgrades share under Share Upgrades.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Both are deduped, so a team can't stack extra copies."
          ]
        },
        {
          "text": "Keysanity keystones are shared as Miscellaneous items, and a location only ever grants one.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Controlled by Share Miscellaneous Items."
          ]
        },
        {
          "text": "Keystones your teammates find are no longer granted to you again every few seconds.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Pickups that take a skill away are never shared in co-op.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.1",
      "date": "2025-04-04",
      "changes": [
        {
          "text": "Enhanced Dashes started on the ground go straight unless you aim more than 20 degrees up.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "An Enhanced Dash into the ground becomes a grounded dash.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The Swamp drain finishes instantly with Enhanced Clean Water.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Seeds that aren't Enhanced no longer give you Enhanced Spirit Flame.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Projectiles no longer lose their collision after Enhanced Charge Flame catches them.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Enhanced Charge Jump no longer spams explosions when you pass through projectiles.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Enhanced Stomp and Enhanced Dash turn Ori to face the way you're traveling.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Enhanced Clean Water clears the water it was missing in the Hollow Tree.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed Enhanced Climb misbehaving on walls.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added patch notes links to the Misc menu and a changelog link to the seed generator.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Changing only your team name in site settings no longer errors.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Misc menu dropped the Weekly Race Poll and Open Book Seed Challenge links.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Fixed the Randomize! button rolling absurd experience pools and leaving settings from the last roll in place.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Keysanity no longer throws off your World Tour relic count.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Ginso spawn in Keysanity starts you with Upper Ginso keystones.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.1.0",
      "date": "2025-04-01",
      "title": "Happy 10th Oriversary!",
      "headline": "A long-overdue update, released for the 10th anniversary of Ori and the Blind Forest. Alongside the fixes below, your friendly neighborhood devs shipped some features on April 1, a date with no special significance whatsoever. Please enjoy them in the true spirit of April 1, which is, again, just a day like any other. :)",
      "changes": [
        {
          "text": "The Blackroot Burrows door to the boulder chase area is now permanently open in every mode.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Standard logic no longer requires a Rekindle to glitch it open. Casual paths are unchanged for now."
          ]
        },
        {
          "text": "Spirit Flame autofire now runs at 20 Hz, up from 10.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Enhanced Climb also gives you Wall Jump.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "New Disable Menu Blur setting, which turns off the background blur during Save Anywhere glitches.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "If you run a low Save Anywhere opacity, you may want to raise it when using this."
          ]
        },
        {
          "text": "The default Toggle Chaos Mode bind has been removed, and is cleared the first time you run 4.1. You can add one back yourself.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Keystone doors on the world map now name themselves when you hover them.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The in-game logic map handles keystones far more sensibly, and pickups that were already in logic no longer vanish when you pick up more skills.",
          "category": "Game",
          "type": "fix",
          "importance": "major",
          "sub": [
            "The map assumes you can open any keystone door you have enough keystones for, regardless of which other doors you can reach.",
            "Doors in succession still add their costs together.",
            "The map remembers which doors you've already opened."
          ]
        },
        {
          "text": "Removed the Improved Spirit Flame setting. Mashing is no longer penalized in any way.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Health and energy cells granted at spawn no longer show pickup messages.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "All Misty Woods pickup icons behave properly on the world map.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the game sometimes removing the Tap Double Bash setting from RandomizerRebinding.txt.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed highlighting on the randomizer's custom menus.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed errors during the prologue.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Valley stomp post starts already stomped in Open World.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "World Tour saves from before 4.1 lose their relic count.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Randomizer Randomizer: the Randomize! button on the front page rolls you a completely random set of seed settings.",
          "category": "Website",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Any number of variations may be selected, each with its own probability.",
            "Any goal mode may be selected -- possibly several.",
            "Logic preset, key mode and item pool are all in play too, with some options more common than others."
          ]
        },
        {
          "text": "Item pool selection moved to the top bar. Pool customization still lives in the item pool tab.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The plando editor has new Show Loc Names and Show Styleguide display toggles.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Show Styleguide puts the message formatting legend on the map."
          ]
        },
        {
          "text": "Every ability tree bonus item can now be placed by name in the plando editor.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "A batch of small plando fixes.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed dark mode refusing to turn back off.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Multi-line seed descriptions now display on more than one line.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Game history pages no longer break when their seed is gone.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Legacy Kuro Behavior, Strict Mapstones and Closed Dungeons moved to a Legacy Flags row in the advanced tab.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "New variation: Keysanity. Each keystone opens one specific door, and keystone duplication doesn't work.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Alt+K displays the keystones you've collected for each door.",
            "Visiting a door gives you hints for where its keystones are.",
            "Once you've seen those hints, you can read them again by mousing over the door on the map."
          ]
        },
        {
          "text": "New variation: Enhanced, which enhances the randomizer in ways you could never have imagined.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Enhanced was on by default on the website for the first 48 hours of 4.1."
          ]
        },
        {
          "text": "The first energy cell in Glades is now a randomized pickup.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Glades spawn seeds simply start with an extra energy.",
            "Other spawns get the same health and energy they always did, but can no longer grab a free energy here."
          ]
        },
        {
          "text": "The Forlorn escape plant is a fixed 100 experience pickup again.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed forced cell frequency counting the cells you start with against the forcing rate.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor",
          "sub": [
            "Casual seeds get much more consistent early health progression.",
            "Standard seeds should see slightly fewer health-starved situations."
          ]
        },
        {
          "text": "Fixed the generator mishandling Open World paths in non-Open World seeds, which sometimes placed three ability cells for no reason.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed paths with ability cells being chosen as forced progression less often than they should have been.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed shards being duplicated in the spoiler, and relics being missing from it. The spoiler now names each relic instead of saying 'Relic'.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Item pool presets each contain one more energy cell.",
          "category": "Seed Generator",
          "importance": "minor",
          "sub": [
            "Custom item pools now need at least 4 energy cells."
          ]
        },
        {
          "text": "Logic changes across outer Swamp, the Grotto teleporter pickups, the Water Vein area, and exiting lower Sorrow, several contributed by the community.",
          "category": "Logic",
          "importance": "major",
          "sub": [
            "Added the FirstEnergyCell pickup to logic.",
            "Removed Rekindle from the requirements to reach RazielNoArea, since the door is permanently open.",
            "Fixed the Forlorn keystone door not being in logic without the Gumon Seal, so the generator places its keystones as soon as you have the Forlorn TP. The pickups still require the Seal.",
            "LeftGrottoTeleporterExp: added damage boost paths to standard and expert; Double Jump is no longer strictly required in standard. (thanks to d265f27)",
            "Both BelowGrottoTeleporter pickups: damage boosts no longer implicitly require Regroup, and Bash + Grenade paths were added to standard. (thanks to d265f27)",
            "WaterVeinArea from Grotto TP: reachable in standard with only Wall Jump, or Climb, or Charge Jump; reachable in expert with no skills.",
            "Outer Swamp: the hanging XP below the stomp floor needs Clean Water in casual; the Climb + Double Jump health cell path moved to expert, replaced in standard by Climb + Double Jump + Glide; the mortar area plant is in standard via an offscreen Grenade throw; casual now assumes you finish the mortar worm puzzle before taking the mortar area ability cell. (thanks to GreeZ)",
            "Exiting Sorrow: added a Glide + Wind path and several Bash + Grenade paths, including in standard. (thanks to oshiimine, Roryrai, Cleanfel, others)"
          ]
        },
        {
          "text": "Meta Bingo: bingo boards can include 2-5 'meta' squares with conditions about the board itself.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Activate squares require you to complete another specified square, or one of, or all of, a set of them ('Activate B1', 'Activate A4 and C3'). They can reference permanently missable squares.",
            "Symmetry squares require your board to be horizontally or vertically symmetric. Lose the symmetry and you lose the square.",
            "A horizontal symmetry square only appears on row 3 and a vertical one only on column C; if you get both, one of them is C3.",
            "An empty board is symmetric, so these can be discovery bingo starting squares as long as you set more than one."
          ]
        },
        {
          "text": "Discovery bingo tries much harder to place starting squares somewhere sensible.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Bingo boards in Keysanity seeds drop the unspent keystones square and ask for fewer keystone doors.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Seeds generated from the bingo page now default to the Bonus Lite item pool.",
          "category": "Bingo",
          "importance": "minor"
        },
        {
          "text": "Walking onto a teleporter now shares it under Share Teleporters instead of Share Miscellaneous Items.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor",
          "sub": [
            "Horu Fields and Lost Grove have no teleporter pickup, so they still can't be shared this way."
          ]
        }
      ],
      "spoilers": {
        "label": "Enhanced Mode spoilers",
        "changes": [
          {
            "text": "Every skill pickup, and Clean Water, gives you an Enhanced version instead.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Spirit Flame: Sein's voice is restored, and she's here to help.",
            "category": "Game",
            "type": "feature",
            "importance": "major",
            "sub": [
              "Her dialogue is updated to be more relevant and sometimes irreverent.",
              "She'll sometimes hint at a pickup location.",
              "Shift+Alt+U hides her dialogue without hiding the rest of your UI."
            ]
          },
          {
            "text": "Enhanced Wall Jump: has the effects of both Wall Jump and Climb.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Charge Flame: draws in nearby projectiles while you hold it, and sends them back the way they came when you release.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Double Jump: infinite Double Jumps.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Bash: works without a target -- hold the button briefly.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Stomp: aimable in any direction. Start the windup as normal, then hold a direction; you can keep changing direction until you hit something.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Glide: generates its own wind, anywhere.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Climb: immunity to spikes and heat damage.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Charge Jump: holding a charge gives you a damaging aura that kills enemies, breaks nearby terrain, and makes you immune to enemies and their attacks.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Dash: aimable in any direction, and reduces the base energy cost of Charge Dash by 0.5.",
            "category": "Game",
            "type": "feature",
            "importance": "major",
            "sub": [
              "The default KBM Charge Jump bind (W) makes this awkward. Try a separate Charge Jump bind, or a Charge Dash bind with both Charge Jump and Dash on the same key."
            ]
          },
          {
            "text": "Enhanced Grenade: breaks walls and floors.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Enhanced Clean Water: removes water from the world. Yes, really.",
            "category": "Game",
            "type": "feature",
            "importance": "major"
          },
          {
            "text": "Any Enhanced skill other than Spirit Flame, and Enhanced Clean Water, also gives you a bonus skill that toggles Enhanced effects off and on -- Alt+Right Click by default.",
            "category": "Game",
            "type": "feature",
            "importance": "major",
            "sub": [
              "Doesn't affect Enhanced Spirit Flame; use Shift+Alt+U for that.",
              "Useful for getting unstuck if a missing-water situation blocks you."
            ]
          }
        ]
      }
    },
    {
      "version": "4.0.15",
      "date": "2025-03-22",
      "changes": [
        {
          "text": "Fixed renaming a plando.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Reopening a seed with no goal mode set now shows None instead of nothing at all.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Game and history pages no longer break for old games whose seed is gone.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "My Games now lists your ten most recent games.",
          "category": "Website",
          "importance": "minor",
          "sub": [
            "Add ?all to the address for the full list."
          ]
        },
        {
          "text": "Forcing an item onto a mapstone turn-in now works.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Teleporters you activate by walking into them are now shared by Share Teleporters instead of Share Misc.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Horu Fields and Lost Grove still can't be shared this way."
          ]
        },
        {
          "text": "Fixed a caching bug that could make a player miss shared pickups in co-op.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        }
      ]
    },
    {
      "version": "4.0.14",
      "date": "2025-03-16",
      "changes": [
        {
          "text": "Fixed seeds that spawn you outside Glades handing out far more health and energy than intended.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "The item tracker download now points at jeflefou's tracker.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Discovery bingo now starts you closer to the middle of the board.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Bingo boards can now roll a few more pickups-in-zone squares.",
          "category": "Bingo",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.13",
      "date": "2025-03-14",
      "changes": [
        {
          "text": "Reopening a seed's settings now keeps its preplaced items.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the vanilla seed download, the active games list, and bingo userboard pages.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Preplacement now works on any pickup location, and on as many of them as you want.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Find these in the Advanced tab.",
            "Note: Spawn is one of the locations."
          ]
        },
        {
          "text": "Entrance Shuffle is available again.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "The logic map does not understand Entrance Shuffle, and will lie to you."
          ]
        },
        {
          "text": "The Blackroot teleporter is now in the Bonus and Bonus Lite item pools.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Dungeon teleporters can be locked behind their clue in Clues mode.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "The experimental ClueLockedTPs seed flag. Two shards of that dungeon's key also unlocks it."
          ]
        },
        {
          "text": "Lowering an item pool entry's maximum no longer lowers its minimum with it.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Strict Mapstones is no longer on the variations list.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "Bingo ability goals now say which tree the ability is in.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed bingo seeds opening in the browser instead of downloading.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Bingo now stays in the goal mode list when tracking is off, grayed out.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Spirit Light Efficiency bingo goal is now called Spirit Potency.",
          "category": "Bingo",
          "importance": "minor"
        },
        {
          "text": "The Blackroot and Glades teleporters are now shared in co-op.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed most pickups not being reported to the tracker or to other players.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        }
      ]
    },
    {
      "version": "4.0.12",
      "date": "2025-03-11",
      "changes": [
        {
          "text": "RandomizerSettings.txt now explains what every setting does.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Replaying your good luck message shuffles the words.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "RandomizerSettings.txt and RandomizerRebinding.txt are rewritten in full when they change, so hand edits survive an update.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed 4.0.11 breaking preplaced pickups, spawn items, and items handed to you in multiplayer.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "The controller Back button is now listed correctly as _Back in RandomizerRebinding.txt.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Some settings and binds have been renamed.",
          "category": "Game",
          "importance": "minor",
          "sub": [
            "Grenade Jump Mode: 'Free' -> 'Auto'",
            "Hints: 'Skilled' -> 'Experienced'",
            "Default Map Filter: 'All' -> 'Uncollected'",
            "Binds: 'Return to Start' -> 'Warp'",
            "Binds: 'Free Grenade Jump' -> 'Grenade Jump'",
            "Your settings and rebinding files update themselves."
          ]
        },
        {
          "text": "Improved Spirit Flame and Blackroot Orb Room Climb Assist are no longer settings.",
          "category": "Game",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.10",
      "date": "2025-03-03",
      "changes": [
        {
          "text": "The Spirit Tree pickup no longer appears twice on the map.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The site has been rebuilt on Python 3 and Flask.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Warps are now sharable in co-op modes.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        }
      ]
    },
    {
      "version": "4.0.9",
      "date": "2025-01-23",
      "changes": [
        {
          "text": "Plando pickups can now take things away instead of giving them.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Health cells, energy cells, ability cells, keystones and mapstones.",
            "Write the amount as a negative, like HC|-1."
          ]
        }
      ]
    },
    {
      "version": "4.0.8",
      "date": "2024-11-05",
      "title": "The Map Update",
      "changes": [
        {
          "text": "The in-game map now shows the whole world, grayed out where you have not been.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Misty and its pickups now show on the in-game map.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Collected pickups no longer show on the in-game map.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Map pickup tooltips now name the area the pickup is in.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The map starts further zoomed out and can be scrolled anywhere.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Zooming out no longer drops you from the area map to the world view.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "The teleporter map still zooms out."
          ]
        },
        {
          "text": "Grenades now explode on blue plants instead of bouncing off them.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The In Logic map filter now works when you pick your own logic paths instead of a preset.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "The In Logic map filter now accounts for the Glades teleporter and for warps.",
          "category": "Game",
          "type": "fix",
          "importance": "minor",
          "sub": [
            "Warps only count in logic on seeds rolled with In-Logic Warps."
          ]
        },
        {
          "text": "The In Logic map filter no longer asks for keystones on the Glades door that Open World leaves open.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Items from other players and items you spawn with now update the In Logic map filter.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added the 2023 tournament champions to the credits.",
          "category": "Misc",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.7",
      "date": "2023-09-28",
      "changes": [
        {
          "text": "Shards past the third now show a count instead of (extra).",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.6",
      "date": "2023-09-09",
      "changes": [
        {
          "text": "Finishing the Forlorn escape now gives you the Stomp and Grenade zone hint automatically.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Sense now only changes Ori's color while it is detecting a pickup instead of keeping Ori the cold color.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "If your Sense cold color is close to your normal color, consider changing one of them."
          ]
        },
        {
          "text": "Added loading tips for changing the Misty layout and for retrying the Forlorn escape.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Warping into the Forlorn escape room no longer moves you if you haven't started the escape.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Retrying the Forlorn escape triggers more reliably and drops you somewhere safer.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added a Reroll Last Seed button that rolls a new seed with your last seed's settings.",
          "category": "Website",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Only available while signed in."
          ]
        },
        {
          "text": "Game history now lists the warps you have picked up.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The plando editor can now mark a seed hidden.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed turning on any variation adding bonus warps to the item pool.",
          "category": "Website",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "The plando editor no longer drops flags it doesn't recognize.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Clearing every exclusion in the spoiler options now shows every pickup.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Starting skills now show up in the spoiler.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Items handed to you by another player now show their names in the spoiler.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Turning on the Race variation now fills in the doubles tournament settings.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "Reaching the Three Birds ability cell with Dash and Double Jump is now expert instead of standard.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Bonus warps are now shared in co-op when Teleporters are shared.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.5",
      "date": "2023-03-18",
      "changes": [
        {
          "text": "Added Randomized Experience Names feature to put some variation in your Spirit Light Pickups.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Relevant setting: Randomized Experience Names in RandomizerSettings.txt."
          ]
        },
        {
          "text": "Finished goals now show up green in the progress readout.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Seeds without shards or clues now show which dungeon keys you have instead of a shard count.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Removed the Will of the Wisps map.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Spoilers can now include Experience and Bonus pickups.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Enable via the Verbose Spoiler option in the Advanced tab."
          ]
        },
        {
          "text": "Spoilers now use full item names and line up in columns.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Random spawn weights can be set per location in the Advanced tab.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Non-Glades spawns fail to generate far less often.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Lowering an item's Up To value in the item pool now lowers its count to match.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Custom logic files can now put a comment at the end of a line.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Added lockout bingo, where a square goes to the first team that completes it.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Enable it in the board setup screen after switching the goal from lines to squares."
          ]
        },
        {
          "text": "Fixed multiplayer seeds treating everyone but the first player as spawning in Glades.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Added 2Kil to the credits.",
          "category": "Misc",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.4",
      "date": "2022-09-22",
      "changes": [
        {
          "text": "Turning disco sense off now actually turns disco sense off.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Logic checking tools no longer literally always tell you that you can get the EC on the way to Sein.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Random spawn selection is now weighted, and you can set the weights yourself.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed single pickups on spawn not being granted when spawning outside of Glades.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Glades teleporter is now shared in co-op.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.3",
      "date": "2022-09-21",
      "changes": [
        {
          "text": "Added safeties to reduce the odds of item deletions happening.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Leveling up while warping no longer deals damage, so the Blackroot fronkey can survive it.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Removed two beta-only settings that weren't meant to ship.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.2",
      "date": "2022-09-14",
      "changes": [
        {
          "text": "The areas.ori file the logic helper needs is now downloaded automatically by the game.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        }
      ]
    },
    {
      "version": "4.0.1",
      "date": "2022-09-14",
      "changes": [
        {
          "text": "Fixed backwards compatibility for the built-in reachability check.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed reachable checks on the web map not working at all.",
          "category": "Website",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed Glades spawn seeds not generating.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Removed some logspam for bingo teleporter activation.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "4.0.0",
      "date": "2022-09-14",
      "title": "4.0 hype!",
      "changes": [
        {
          "text": "Alt+R now opens the warp map and lets you teleport to any activated Spirit Well from anywhere, just like teleporting in Ori 2.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "In-game logic helper: see which pickups are actually in logic without leaving the game.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Set Toggle Map Mode in RandomizerRebinding.txt to switch between all uncollected and in-logic pickups (defaults to Grenade).",
            "You can set which filter the map opens with by default."
          ]
        },
        {
          "text": "Revamped difficulties. Easy, Normal and Hard are now Relaxed, Challenging and Punishing.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Set Default Difficulty in RandomizerSettings.txt to pick what you get if you just spam proceed on a new file.",
            "Relaxed grants some abilities in each tree at the start and makes parts of the game easier, including the Blackroot Burrows orb room."
          ]
        },
        {
          "text": "Grenade jumps can be bound to a single key instead of needing two presses a frame apart.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Set Free Grenade Jump in RandomizerRebinding.txt; it defaults to Grenade+Jump.",
            "Set Grenade Jump Mode to Manual in RandomizerSettings.txt if you'd rather keep the skill sharp."
          ]
        },
        {
          "text": "Hints: custom hints play every time you teleport with Alt+R.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Set Hints in RandomizerSettings.txt to NewPlayer, Skilled or Disabled."
          ]
        },
        {
          "text": "Mouse aim: use your mouse to aim where you swim, and to aim a climb + charge jump during a wall charge.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Relevant settings: Wall Charge Mouse Aim and Swimming Mouse Aim in RandomizerSettings.txt, on or off at any time."
          ]
        },
        {
          "text": "Spirit Flame autofire: have Sein fight enemies automatically when they're in range.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Off, Hold or Toggle.",
            "On Hold, a normal Charge Flame requires holding the Suppress Autofire bind (defaults to Grenade, same as Double Bash) when you press Spirit Flame. Toggle doesn't have this quirk."
          ]
        },
        {
          "text": "Invert Climb and Invert Swim: with Climb, touching a wall makes Ori hang on by default, and you release with your Glide bind.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Sound compression, to cut down the volume spikes in places like Spirit Caverns.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Relevant setting: Apply Sound Compression in RandomizerSettings.txt, with Sound Compression Factor to control how equalized it gets.",
            "You may want to adjust the in-game sound effects volume afterwards."
          ]
        },
        {
          "text": "Camera shake can be reduced or turned down.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Camera Shake Factor in RandomizerSettings.txt scales it (0.75 for 75%).",
            "Reduce Camera Shake: True heavily cuts shaking across the whole game."
          ]
        },
        {
          "text": "Blackroot orb room climb assist adds a few frames of forgiveness to the climb ramp, taking most of the luck out of a climb start without keystones.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Most randomizer options can now be changed from the in-game menu.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "New Controls and Accessibility pages under Options, with a description for every option."
          ]
        },
        {
          "text": "Keyboard and controller controls can be rebound in-game, menu controls included.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "You can drag a seed file onto the game window to load it.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Any file named randomizer*.dat works, and Alt+L keeps reloading that file."
          ]
        },
        {
          "text": "The map has its own icons for skill trees, plants, Horu rooms and world event pickups.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "With this many new options, it's worth deleting RandomizerSettings.txt and RandomizerRebinding.txt and letting the dll write fresh, better-organized ones.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Mousing over a pickup on the map now tells you what it is.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The map now shows your current goal.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Area completion percentage now counts the pickups you've collected there.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Map Markers is now Maphacks, and reveals the whole world map.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The game no longer forces your map open.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Pickup messages can stack down the side of the screen instead of playing one at a time.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Relevant settings: Display Multiple Pickup Messages and Always Show Last Five Pickup Messages in RandomizerSettings.txt.",
            "Hold your Replay Message bind to show the last five."
          ]
        },
        {
          "text": "The inventory screen shows your shard counts and dungeon key clues under each key.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Ability tree upgrades have accurate names and descriptions, and list the total points needed to reach them.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "A new bind lists every bonus passive you're carrying.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Relevant bind: Show Bonuses in RandomizerRebinding.txt, defaults to Alt+B."
          ]
        },
        {
          "text": "Climbing up over an edge no longer flings you forward.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Relevant setting: Slow Climb Vault in RandomizerSettings.txt."
          ]
        },
        {
          "text": "Bash aim can be held for five seconds instead of 1.7.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Relevant setting: Longer Bash Aim Time in RandomizerSettings.txt."
          ]
        },
        {
          "text": "Alt+R opens the map with the nearest teleporter already selected.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The area map zooms out further.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The pause menu wraps around when you scroll past the end.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The game now boots straight to the main menu.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Returning to Forlorn after the escape puts you back at the start of the escape.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Misty Woods now tells you that the orb pedestal changes the layout, and which layout you're in.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed a pile of Alt+R softlocks, including warping mid-bash and warping during the Grotto and Ginso minibosses.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Leveling up while warping no longer kills you.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Sein and Spirit Flame no longer break after teleporting to a warp.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Warping out of water no longer leaves you swimming through the air after a reload.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Saving at a teleporter no longer eats your temporary health and energy.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Horu R4 lasers turn off once you finish the room.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Grotto bridge finishes building even if you drop past it.",
          "category": "Game",
          "type": "fix",
          "importance": "minor",
          "sub": [
            "Relevant setting: Fix Grotto Bridge Drop in RandomizerSettings.txt."
          ]
        },
        {
          "text": "The music in inner Swamp plays again.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Health and energy regeneration no longer changes with your framerate.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Alt-tabbing out no longer wrecks your framerate or mutes the game.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Teleporters sitting close together on the warp map are easier to click.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Jump upgrades no longer send your double jump to the moon.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Credits updated with more of the people who helped, and the 2021 Randomizer Tournament finalists.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "The Glades spirit well cutscene is gone.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "You can set your spawn location from a dropdown above the main area when rolling seeds, including a random spawn option.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "You can set how much health, energy and how many skills you start with.",
          "category": "Website",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Relevant options: Random Starting Health, Random Starting Energy and Random Starting Skills in the Advanced tab.",
            "Picking a Non-Glades spawn autofills these based on your logic mode."
          ]
        },
        {
          "text": "More player icons for the tracking map.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "New variation: In-Logic Warps, which adds warps to the map that become part of the seed's progression and opens up logic paths never seen before.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Alt+R opens the map and shows a warp teleporter icon. Set Warp Teleporter Color in RandomizerSettings.txt to tell them apart from normal teleporters."
          ]
        },
        {
          "text": "New variation: Race, which hides the game's trackers and history from spectators.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "The Spirit Tree XP orb is now a randomized pickup.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plandos can place Lose Sein and Free Level Explosion.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The Hard item pool no longer includes the Ginso, Forlorn and Horu teleporters.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "Added a grenade jump path across the Horu L4 lava chase.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "The item tracker can be pointed at a single player in a co-op game.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.4.5",
      "date": "2019-12-31",
      "changes": [
        {
          "text": "Plandos can optionally specify that warping while carrying an orb does not auto-drop it.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Add 'orbwarp' as a flag to enable this."
          ]
        },
        {
          "text": "Fixed seeds without clues breaking when a multipickup contained a dungeon key.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed the item tracker not showing trees and relics in single player.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The site now requires DLL version 3.4.4 or newer.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Item pool counts can now be set to zero.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed bingo boards on Hard failing to generate in discovery mode.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Discovery boards now pick their starting squares from early-game goals, and ask smaller counts of them.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Multiplayer games now have an icon for the eleventh player.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.4.4",
      "date": "2019-12-25",
      "changes": [
        {
          "text": "Fixed bingo squares and pickup stats counting a location you had already collected.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        }
      ]
    },
    {
      "version": "3.4.3",
      "date": "2019-12-24",
      "changes": [
        {
          "text": "Plando messages can now set their own duration, or silence the rest of their multipickup.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "d=120 makes a message stay active for 120 frames (2 seconds).",
            "s=true hides the item messages that follow it."
          ]
        },
        {
          "text": "Pickups that take an ability away now actually take the ability away.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        }
      ]
    },
    {
      "version": "3.4.2",
      "date": "2019-12-23",
      "changes": [
        {
          "text": "Jump Upgrades now boost Charge Jump and wall Charge Jump.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Wall Charge Jump's invincibility no longer grows with upgrades."
          ]
        },
        {
          "text": "Skill Velocity Upgrades boost Charge Jump by 8% each, down from 10%.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Skill Velocity Upgrades no longer extend the wall charge jump invincibility window.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "In co-op, items your teammates send you no longer count as pickups you found yourself.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Co-op games that aren't cloned seeds no longer skip key shards a teammate already found.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        }
      ]
    },
    {
      "version": "3.4.1",
      "date": "2019-12-01",
      "changes": [
        {
          "text": "Fixed the site losing track of the pickups you'd collected partway through a game.",
          "category": "Website",
          "type": "fix",
          "importance": "major",
          "sub": [
            "Affects the map, the item tracker, and co-op item sharing."
          ]
        }
      ]
    },
    {
      "version": "3.4.0",
      "date": "2019-12-01",
      "changes": [
        {
          "text": "Jump Upgrades now also boost wall jumps and jumping out of water.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "New Cursor Lock setting, which keeps your mouse inside the game window.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Relevant setting: Cursor Lock in RandomizerSettings.txt."
          ]
        },
        {
          "text": "Sense can now cycle your custom color rotation instead of tinting you hot and cold, cycling faster the closer you get.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Relevant setting: Disco Sense in RandomizerSettings.txt. Needs a custom rotation in Color.txt."
          ]
        },
        {
          "text": "Warp pickups still work when Return to Start is disabled.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Warping now drops whatever you're carrying.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "New Item List spoiler, which lists where the important items are instead of every location.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "The gear button next to View Spoiler switches to it, picks which item types to leave out, and can group the list by zone."
          ]
        },
        {
          "text": "orirando.com/reroll rerolls your most recent seed with the same settings.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The rebinding editor's defaults include left click for Spirit Flame.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The tracker link now points to meldontaragon's tracker.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "New variation: Wall-Starved, which keeps Wall Jump and Climb out of the early game.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Experimental, and feedback is welcome."
          ]
        },
        {
          "text": "TP-Starved now also makes the generator pick teleporter progression paths less often.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added Spirit Cavern AC and Dash Plant as warp pickup destinations.",
          "category": "Seed Generator",
          "importance": "minor",
          "type": "feature"
        },
        {
          "text": "Fixed custom Sense triggers being silently dropped from generated seeds.",
          "category": "Seed Generator",
          "importance": "major",
          "type": "fix"
        },
        {
          "text": "Warp pickups can no longer overwrite preplacements.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "New bingo mode: Discovery. Most of the board starts hidden, and completing a square reveals the ones next to it.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major",
          "sub": [
            "The squares you start with are picked from goals that should be easy to achieve early."
          ]
        },
        {
          "text": "You can set how many lines a bingo game takes to win when you roll the seed in addition to at bingo game creation.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Enable via Bingo Lines in the Advanced tab."
          ]
        },
        {
          "text": "Bingo boards can hide everyone's progress and the event log for blind races.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Add blindRace as a url param to the board link."
          ]
        },
        {
          "text": "The bingo timer counts down to the start of the game instead of sitting at zero.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed bingo boards permanently stopping updates after a long stretch with no completed squares.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed the game file for bingo games that aren't attached to a randomizer seed.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Bingo progress keeps updating after a connection error instead of going quiet.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Collecting a location you already have no longer counts again toward bingo goals or your pickup count.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed bingo boards attached to vanilla+ seeds failing to generate.",
          "category": "Bingo",
          "importance": "minor",
          "type": "fix"
        }
      ]
    },
    {
      "version": "3.3.5",
      "date": "2019-09-21",
      "changes": [
        {
          "text": "Added the Jump Upgrade bonus pickup, which upgrades your jumps and double jumps.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Skill Velocity Upgrade now speeds up climbing too.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Toggle Skill Velocity is now Toggle Movement Bonuses, and switches off Jump Upgrades as well.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Jump Upgrade can be placed from the plando editor.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed the Discord link in the quickstart guide.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Extra Bonus and Bonus Lite item pools now include three Jump Upgrades.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Extra Double Jumps in the Extra Bonus and Bonus Lite pools dropped from five to three to make room for Jump Upgrades.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "Fixed shards going missing in co-op games where players have different seeds.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "World Tour relics no longer count as Glades relics when you alt+R right after grabbing one.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Co-op hands back shared bonus items you are missing entirely, not just ones you are short on.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the item tracker over-counting mapstones in co-op games.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.3.4",
      "date": "2019-09-13",
      "changes": [
        {
          "text": "Spectate links now follow a player into their next game and show only their map.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The help text for Dedup Shared now describes what the option actually does.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The tracker and logic maps have a dark background instead of a white one.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Casual logic no longer asks you to break blue walls with Stomp.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Casual now expects Charge Jump and Bash in the Horu L2, L3, R2 and R3 rooms, with the old routes moved to Standard.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Fixed team bingo boards not updating.",
          "category": "Bingo",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed dungeon teleporters not activating and goal modes not completing in online games.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        }
      ]
    },
    {
      "version": "3.3.3",
      "date": "2019-09-09",
      "changes": [
        {
          "text": "The out of date randomizer warning now shows in all tracked seeds, not just bingo.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The tracker map now takes URL options for following a player and hiding the panels.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "follow=<player number>",
            "hideSidebar",
            "hideTracker",
            "Spectate links pass these through."
          ]
        },
        {
          "text": "Repeatable pickups no longer count more than once towards bingo goals.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Bingo boards now update within a second of a square changing.",
          "category": "Bingo",
          "importance": "major"
        },
        {
          "text": "Co-op and bingo games can now be restarted without rerolling the seed.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major",
          "sub": [
            "orirando.com/reset/<game id>",
            "Only the person who created the game can reset it."
          ]
        }
      ]
    },
    {
      "version": "3.3.2",
      "date": "2019-08-31",
      "changes": [
        {
          "text": "Clues now work when a key is bundled with other items in one pickup.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Key Mode: Clues"
          ]
        },
        {
          "text": "Fixed the Ginso, Forlorn and Horu teleporters and the goal mode credits warp not unlocking.",
          "category": "Game",
          "type": "fix",
          "importance": "major",
          "sub": [
            "Only affected seeds generated without tracking."
          ]
        }
      ]
    },
    {
      "version": "3.3.1",
      "date": "2019-08-25",
      "changes": [
        {
          "text": "Dark mode and theme choices now stick without logging in.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Settings dropdown, previously named Login."
          ]
        },
        {
          "text": "The item pool editor now describes each bonus pickup you hover over.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The seed page now follows your theme.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Map icons now use preferred player numbers.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "casual-core can no longer be turned off in the plando logic settings.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the tracker download link in the help guide.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added menu links for the weekly race poll and the Open Book seed challenge.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "The login dropdown is now called Settings, so the dark mode and theme controls are easier to find.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Fixed 0XP logic expecting boulder escape routes that need ability upgrades.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Bingo boards now label rows and columns on all four sides.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Add ?hideLabels to the board URL to turn labels off."
          ]
        },
        {
          "text": "Bingo boards can hide their row and column labels, and the labels are now called X and Y instead of x1 and x2.",
          "category": "Bingo",
          "importance": "minor",
          "type": "feature"
        },
        {
          "text": "Items that get taken back can no longer unlock a teleporter or the credits warp.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed blackout messages showing your game placement instead of your blackout placement.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Winning and blacking out on the same update now only announces the blackout.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed two games created at the same moment being able to claim the same game ID.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.3.0",
      "date": "2019-07-24",
      "title": "In-Game Rebinding",
      "changes": [
        {
          "text": "Keybinds can now be changed in-game.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Options > Keybinds and Options > Menu Keybinds",
            "Backspace removes a bind, Enter finishes editing."
          ]
        },
        {
          "text": "Controller buttons can now be rebound.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Options > Controller Binds and Options > Controller Menu Binds"
          ]
        },
        {
          "text": "Stomp is now its own bind, separate from moving down.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed the end-of-game stats screen and credits sometimes not showing.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The tracking map now hides pickups that fall out of logic when you turn paths off.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The map no longer jumps around while following a player.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the Dash and Grenade icons being swapped on the item tracker.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Viewing a plando that doesn't exist now shows an error instead of crashing.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "One Hit KO grays out the casual damage boost paths on the seed generator.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Renamed the tracking map's Track button to Follow.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Added new relics for World Tour.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Seeds now list their item pool preset in the flag line.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed logic around the Double Jump tree in Grotto that could leave you stuck.",
          "category": "Logic",
          "type": "fix",
          "importance": "major",
          "sub": [
            "Some damage boost routes there moved from Casual to Standard."
          ]
        },
        {
          "text": "OHKO seeds no longer allow the Casual damage boost path.",
          "category": "Logic",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed the logic for the grenade pickup in the Glades laser room.",
          "category": "Logic",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed some server messages repeating in-game.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.2.4",
      "date": "2019-06-29",
      "changes": [
        {
          "text": "Fixed skills sometimes not being granted when picked up during a cutscene.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed the item tracker counting the same map stone more than once.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Removed the item tracker links from the game lists.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "The version number now shows on more pages.",
          "category": "Website",
          "importance": "minor"
        },
        {
          "text": "Added the Bonus Lite item pool preset.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Everything from Extra Bonus except the active bonus skills and the repeatable megas."
          ]
        },
        {
          "text": "Mega Health and Mega Energy are no longer used up when picked up in Extra Bonus seeds.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed the Blackroot teleporter not being shared in co-op.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Key shards and Warmth Fragments no longer count twice in co-op.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.2.3",
      "date": "2019-06-23",
      "changes": [
        {
          "text": "Added an item tracker for tracked games, showing skills, trees, events, shards, relics and teleporters.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Linked from My Games and Active Games."
          ]
        },
        {
          "text": "The map tracker sidebar can now show the item tracker.",
          "category": "Website",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Toggle Tracker"
          ]
        },
        {
          "text": "Discrete Mapstones and Legacy Kuro Behavior are no longer offered on the seed generator page.",
          "category": "Website",
          "importance": "minor",
          "sub": [
            "The generator still understands both."
          ]
        },
        {
          "text": "Removed the Discrete Mapstones and Legacy Killplane variations.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "Added bingo goals for the Forlorn laser peg and for dying to the vertical lasers in Misty.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Fixed the Misty Woods bingo goal not counting when you arrive by teleporter.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Respeccing now clears the bingo goals for the abilities you refunded.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed a missing pickup in the underwater pickups bingo goal.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the Forlorn pickup bingo goal asking for more pickups than you can reach.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Removed the Teams option from multiplayer seed generation.",
          "category": "Multiplayer",
          "importance": "minor"
        },
        {
          "text": "The out-of-date dll warning now points at the download page.",
          "category": "Misc",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.2.2",
      "date": "2019-06-01",
      "changes": [
        {
          "text": "Added help text for each item pool preset.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "orirando.com/weekly now takes you to the current weekly poll.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed downloading plando seeds.",
          "category": "Website",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed the map tracker not updating.",
          "category": "Website",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed the map tracker breaking in games where a player hadn't reported a position yet.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed saving plandos that use custom sense data.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "www.orirando.com now redirects to orirando.com.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added a Blackroot teleporter pickup.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Plandos and custom item pools only."
          ]
        },
        {
          "text": "Every World Tour relic now has a real name and description.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The Blackroot teleporter is now shared with your team.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Share Teleporters"
          ]
        },
        {
          "text": "Fixed dungeon teleporters being shared with your team over and over in Shards.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "OriDERandoDecoder.dll is no longer part of setup.",
          "category": "Misc",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.2.1",
      "date": "2019-05-14",
      "changes": [
        {
          "text": "Fixed the Warp to Credits bonus skill firing while Ori can't move.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the broken seed links on the Active Games and My Games pages.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Extra Bonus item pool now includes Underwater Skill Usage.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added the Hard and Competitive item pool presets.",
          "category": "Seed Generator",
          "importance": "minor",
          "type": "feature"
        },
        {
          "text": "Fixed custom item pools loading with the wrong counts.",
          "category": "Seed Generator",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "You can now set a preferred player number, used as your default on bingo boards.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "orirando.com/user/settings/number/<number>"
          ]
        },
        {
          "text": "Trees and teleporters shared by teammates now count toward bingo goals.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed bingo blackout wins being announced over and over.",
          "category": "Bingo",
          "type": "fix",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.2",
      "date": "2019-05-05",
      "changes": [
        {
          "text": "Added plando-usable bonus pickups for every ability in the ability tree.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Also added the ability to remove abilities."
          ]
        },
        {
          "text": "Added the Wither bonus skill.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "(This kills the Ori)."
          ]
        },
        {
          "text": "Added a bonus skill (Toggle Bash/Stomp Damage) that turns off bash and stomp damage.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The relic list keybind now shows which zones have no relic in them.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added pickups that take away any single ability in the ability tree.",
          "category": "Game",
          "importance": "minor",
          "type": "feature"
        },
        {
          "text": "Fixed the randomizer credits failing to load on fast computers.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Pickup hints now name your actual Alt+R bind.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The tree, teleporter, map and relic lists no longer print an empty remaining line.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The credits warp now uses your bonus skill bind instead of Alt+R.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Added an item pool editor to the seed generator.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Added a track button to the map.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed plandos downloading incorrectly straight from the editor.",
          "category": "Website",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added the Skip Final Escape variation.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Finishing your goal modes lets you warp straight to the credits."
          ]
        },
        {
          "text": "Added the TP-Starved variation.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Experimental. Teleporters turn up less often early on."
          ]
        },
        {
          "text": "Added bash and dash routes around Death Gauntlet.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Horu R2 can now be cleared without Bash in Expert.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Added Glide and Stomp lure paths in lower Sorrow.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Added Master Dash routes at the Misty entrance.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "The mapstone plant on the Forlorn approach now accepts Grenade as well as Charge Flame.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Moved the Valley entry redirect to Master.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Removed a batch of redundant paths across Misty, Sorrow and Valley.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Completing a bingo blackout now offers you a warp to the credits.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Bingo boards can now be generated from a seed you choose.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added a timer to the bingo board.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Bingo boards take URL options for card text size and hiding the footer.",
          "category": "Bingo",
          "importance": "minor",
          "type": "feature"
        },
        {
          "text": "Skill trees are now sharable in co-op in the Misc category.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Relics are now sharable in co-op in the Misc category.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Activating a teleporter now activates it for your teammates.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Fixed teleporter activations spamming in co-op.",
          "category": "Multiplayer",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Fixed a typo in the credits.",
          "category": "Misc",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Adjusted where the credit warp drops you.",
          "category": "Misc",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.1",
      "date": "2019-03-23",
      "title": "Bingo",
      "changes": [
        {
          "text": "Added the Invincibility and Level Explosion bonus skills.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Bonus skills now sit in numbered slots that can each be bound directly.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "The relevant bindings are Bonus 1 through Bonus 5 in RandomizerRebindings.txt."
          ]
        },
        {
          "text": "Added a bonus pickup (Underwater Skill Usage) that lets you use Dash and Grenade underwater.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added a bonus skill (Toggle Skill Velocity) that turns Skill Velocity off and on.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "It unlocks automatically with your first Skill Velocity Upgrade"
          ]
        },
        {
          "text": "Extreme Speed now speeds up swimming too.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Respec now tells you how much AP it gave back.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Broken teleporters now tell you how many shards you still need.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added a third stats page showing when and where you found each key item.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Cycling past the last stats page now writes your stats to stats.txt.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Show Stats"
          ]
        },
        {
          "text": "Starting a new game now reloads your seed automatically.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added a setting (Invert Swim) to invert the swim boost button.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Settings you are missing are now added to RandomizerSettings.txt automatically.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Fixed a softlock in the Ginso escape cutscene.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "The Ginso escape now drops you into Swamp even without Bash.",
          "category": "Game",
          "type": "fix",
          "importance": "major"
        },
        {
          "text": "Bonus skills with a continuous energy cost now switch themselves off when you run out of energy.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Stats are much more accurate about which zone you were in.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the nightberry snapping back to the start of Forlorn when you die after teleporting there.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The Forlorn teleporter pickup no longer looks like a relic.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Alt+R is now disabled while you are warping.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed exiting to the main menu during the prologue.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Stats no longer carry over between games.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed a swim animation glitch.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Bonus skill messages no longer queue up behind each other.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed line wrapping in the credits.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Spirit Light Efficiency now stacks additively with the purple tree abilities that grant extra spirit light, instead of multiplicatively.",
          "category": "Game",
          "importance": "major"
        },
        {
          "text": "Gravity Swap now flips Ori rather than forcing gravity in one direction.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Draining bonus skills need a little more energy before they will activate.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Energy Leech restores much less energy.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Renamed several bonus pickups and bonus skills.",
          "category": "Game",
          "importance": "minor",
          "sub": [
            "Lifesteal -> Health Leech",
            "Manavamp -> Energy Leech.",
            "Roose's Wind -> Teleport to Last AltR",
            "Respawn Without Dying -> Teleport to Soul Link"
          ]
        },
        {
          "text": "Nothing pickups no longer print a message.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Spirit Light Efficiency now stacks additively with itself.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Skill Velocity Upgrade now boosts dashes twice as much.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Health and Energy Leech no longer credit overkill damage.",
          "category": "Game",
          "importance": "minor"
        },
        {
          "text": "Added user accounts.",
          "category": "Website",
          "type": "feature",
          "importance": "major",
          "sub": [
            "You can rename yourself and your team once logged in."
          ]
        },
        {
          "text": "Added a dark theme.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Added help and guides pages.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "The seed generator now explains each option as you hover over it.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Added an event log to games.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Player names now show on the map and on the bingo board.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added a page listing your recent games.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The plando editor's pickup selector now handles multiple copies of the same item.",
          "category": "Website",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added Sense Triggers.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Choose which pickup types Sense points you toward."
          ]
        },
        {
          "text": "Warmth Frags now lets you set how many fragments exist and how many you need separately.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plandos can now place repeatable pickups.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plandos can now grant pickups the moment you spawn.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Plandos can now disable and re-enable Alt+R.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Glades and Blackroot teleporters can now be placed in plandos.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added a warp pickup variant that saves your game when you arrive, and warps can now be forced instead of optional.",
          "category": "Seed Generator",
          "importance": "minor",
          "type": "feature"
        },
        {
          "text": "Zero Experience seeds no longer give spirit light from enemies.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "More Bonus Pickups now picks its bonus skills at random rather than always handing out the same ones.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "Rebalanced how the generator weights progression items.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "Limit Keys now places its three keys anywhere in its pool instead of favouring the same handful of spots.",
          "category": "Seed Generator",
          "importance": "minor"
        },
        {
          "text": "Added a missing path to the right hanging exp in Gumo's Hideout.",
          "category": "Logic",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Added missing paths inside Ginso.",
          "category": "Logic",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Removed impossible paths in Spirit Caverns and around the Glades laser area.",
          "category": "Logic",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Fixed the paths across Valley to the Misty entrance.",
          "category": "Logic",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "The four energy door in Death Gauntlet now only has to be paid for once.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Horu L1 now requires Stomp.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Added Open World routes across Valley and into Misty.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Kuro's perch exp is now reachable from lower Valley.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Damage boost paths now state how much health they expect.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Reclassified a large number of paths between the core, damage boost and abilities groups.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Iceless is now reachable from upper Grotto with Air Dash and Climb.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "The hidden spider exp in Forlorn moved from Standard to Expert.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Seeds rolled on the Glitched preset no longer include the Master paths.",
          "category": "Logic",
          "importance": "minor"
        },
        {
          "text": "Added bingo to the core randomizer.",
          "category": "Bingo",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Bingo used to ship as its own dll alongside the randomizer."
          ]
        },
        {
          "text": "Added team play and a spectator board to Bingo.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Bingo boards can be generated at easy, normal or hard difficulty.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Bingo cards now carry help text explaining exactly what counts.",
          "category": "Bingo",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Added the Split Shards co-op mode, which splits each dungeon key's shards between players.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Winning a co-op game now offers you a warp straight to the credits.",
          "category": "Multiplayer",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Co-op seeds are now fully cloned by default.",
          "category": "Multiplayer",
          "importance": "major"
        },
        {
          "text": "Upgrades are now shared by default.",
          "category": "Multiplayer",
          "importance": "minor"
        }
      ]
    },
    {
      "version": "3.0",
      "date": "2019-01-01",
      "title": "The 3.0 release",
      "headline": "The randomizer moved to orirando.com in 3.0, and every logic path in the game was revisited. These notes are ported from the original 3.0 release document; dates before 4.0 are approximate.",
      "changes": [
        {
          "text": "The purple (utility) ability tree has been reworked.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Seeing partially through walls, normally from Sense, is now always active.",
            "Map Markers gains every later Markers ability, shows all hidden pickups, and shows petrified plants as experience orbs.",
            "Ability Markers now gives 50% bonus exp (rounded down); Spirit Light Efficiency combines with it for the same 100% as before.",
            "Life Markers and Energy Markers now give 2 health and 2 energy regen levels respectively.",
            "Sense now changes Ori's color based on distance to the nearest skill, world event, dungeon key, shard or warmth fragment. Colors are set in RandomizerSettings.txt.",
            "Health and Energy Efficiency and the Magnets are unchanged, but Efficiency no longer increases regen rate."
          ]
        },
        {
          "text": "Finishing a Horu room's lava-lowering cutscene now also gives a pickup, whether or not you're playing Open Dungeons.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "The Kuro cutscene in Hollow Grove and the kill plane in Valley are now always present by default, instead of only appearing once you have Stomp.",
          "category": "Game",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Legacy Kuro Behavior restores the old behavior.",
            "Open World removes them entirely."
          ]
        },
        {
          "text": "Returning to the top of the Ginso escape after completing it teleports you to its normal exit in Swamp, so this is now a logical way into Swamp.",
          "category": "Game",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "Teleporting into Forlorn moves the gravity orb to the teleporter; Alt+R sends it back to the start of the dungeon.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The cutscene after the Ginso escape is gone -- you get control back instantly. Your UI will be off; press Alt+U two or three times to restore it.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "The input lock when falling into Gumo's Hideout after you've already been to the bottom now lifts itself within 4 seconds.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Alt+R back to the start now zeroes your speed and snaps the camera instead of panning. It doesn't take any longer.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Health and energy only update visually each quarter cell, so you can appear to be at 0 health while actually between 0 and 0.24.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Health and Energy Regeneration now tick once per 60 seconds per pickup, up from once per 83.3.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Charge Flame now costs 0.5 energy by default; Charge Flame Efficiency reduces that to 0.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Messages for important pickups linger longer.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "RandomizerSettings.txt has more options -- delete the file and press Alt+L for a fresh default one.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Controller Bash Deadzone (0.0-1.0): the analog deadzone when bashing with a controller. Default 0.5; the vanilla game uses 0.04.",
            "Ability Menu Opacity (0.0-1.0): fades the ability menu while moving in a save anywhere. Default 0.5.",
            "Instant Grenade Aim: snap the Grenade target to your analog stick instead of moving toward it. Default False.",
            "Grenade Aim Speed: how fast the Grenade target moves when aiming with a controller.",
            "Cold Color and Hot Color: Ori's colors when far from and near to hot pickups."
          ]
        },
        {
          "text": "RandomizerRebindings.txt includes many more binds. Take a look at the file to see what's available.",
          "category": "Game",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Custom colors: create Color.txt in the Ori DE directory to set Ori's color, or define a rotation that shifts between colors over a set number of frames.",
          "category": "Game",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "A single line of R,G,B,A sets one fixed color.",
            "A CustomRotation block takes a starting R,G,B,A followed by R,G,B,A,F lines, where F is how many frames to spend shifting to that color. The rotation loops back to the first line.",
            "You can fade in and out of visibility, rotate through bright colors, or become a stop light.",
            "Color shift overrides other color options and auto-inputs a color code when activated."
          ]
        },
        {
          "text": "Returning to the start of the game from left Grotto no longer displaces you into Blackroot.",
          "category": "Game",
          "type": "fix",
          "importance": "minor"
        },
        {
          "text": "Bonus item changes.",
          "category": "Game",
          "importance": "major",
          "sub": [
            "Explosion Power Upgrade is gone.",
            "Spirit Flame Upgrade -> Damage Upgrade: +1 Spirit Flame damage, +1 Spirit Flame target, +3 Grenade damage, +1 Grenade burst radius, +6 Charge Flame damage."
          ]
        },
        {
          "text": "The randomizer has a new home at orirando.com. All other sites and seed generators have been replaced.",
          "category": "Website",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "New goal mode: World Tour. Eight zones are chosen at random, a relic is hidden in each, and you need all eight before you can enter the final escape.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Relics have their own names and flavor text.",
            "Best played on the shards key mode with force trees off.",
            "If you like 100%ing the game, you can play with 11 relics -- one in every zone."
          ]
        },
        {
          "text": "New variation: Open Dungeons, on by default. Turn it off with the Closed Dungeons option.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "Keystone doors open from either side.",
            "The elemental miniboss doors in Ginso are open.",
            "The Forlorn orb cutscenes are gone -- the bridge is raised, the laser room door is open, and you can't lose the orb, so most Forlorn pickups need no skills.",
            "The lava blocking each Horu room and the bottom of the mountain is gone.",
            "The Ginso and Horu teleporters are in the drop pool."
          ]
        },
        {
          "text": "New variation: Open World, off by default, which opens up the world outside the dungeons.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major",
          "sub": [
            "The 2 keystone door near the start is open, and the cutscene teaching you about doors is gone.",
            "The Stomp and lever doors from the Spirit Tree to Valley are open.",
            "The Kuro kill plane in Valley and the Kuro cutscene in Hollow Grove are removed."
          ]
        },
        {
          "text": "Every pickup now has a unique name in the spoiler. No more map-and-compass work to figure out which LeftSorrow keystone you missed.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "In shards mode, the Ginso, Forlorn and Horu teleporter pickups don't grant access to that teleporter until you have at least 2 shards of the matching key.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "major"
        },
        {
          "text": "When forcing progression, the generator reduces its chosen path to the smallest subset that still opens progression, so fewer progression items get forced overall.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "When forcing progression, paths with more requirements are chosen much less often, in inverse proportion to how many they have.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Mapstones are no longer placed as soon as a map altar becomes accessible. Strict Mapstones turns this off; it's not allowed with Discrete Mapstones.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Casual and standard seeds now have a minimum health and energy cell rate -- 1 per 20 pickups in casual, 1 per 40 in standard.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor",
          "sub": [
            "Being stuck on 3HP after full clearing the right side of the map is now impossible."
          ]
        },
        {
          "text": "The final escape has no logical requirements any more. Every other location is filled first and the remaining item goes there, so the final escape item varies far more.",
          "category": "Seed Generator",
          "type": "feature",
          "importance": "minor"
        },
        {
          "text": "Every logic path has been revisited and rewritten to model what you can actually reach with a given set of skills.",
          "category": "Logic",
          "importance": "major",
          "sub": [
            "Paths are much more granular. Late-game areas like Misty and Sorrow now open incrementally instead of all at once with one skill combination."
          ]
        },
        {
          "text": "Casual: complicated Bash + Grenade paths (like throwing a Grenade above spikes to bash off it) are no longer required, and neither is damage boosting on spikes.",
          "category": "Logic",
          "importance": "major"
        },
        {
          "text": "Standard: up to 3 damage per damage boost path, Air Dash and Climb + Charge Jump floor breaks are now in logic.",
          "category": "Logic",
          "importance": "major",
          "sub": [
            "Damage boosts still aren't required for the upper path to Valley or inside Misty Woods.",
            "Underwater pickups in dirty water are never required, at any damage amount.",
            "The randomizer provides 3 Ability Cells for the Air Dash paths."
          ]
        },
        {
          "text": "Expert: up to 6 damage per damage boost, Double Bash chains, wall vaults with Double Jump, and Charge Dashes on every pickup.",
          "category": "Logic",
          "importance": "major",
          "sub": [
            "Double Bash paths expect at most 5 or 6 chained bashes.",
            "Double Jump may be expected to vault walls that are barely too high -- jump into the wall, then press jump again.",
            "The randomizer provides 6 Ability Cells for the Charge Dash paths."
          ]
        },
        {
          "text": "Master: a lot more microledges and terrible damage boost paths. Sorry not sorry.",
          "category": "Logic",
          "importance": "major",
          "sub": [
            "Double Jump may be expected to act as wall interaction: jump into the wall, turn away briefly, turn back and jump again, as many times as needed.",
            "Grenade jumps are in, and there are many more of them than there used to be.",
            "Triple Jump and Ultra Defense are explicitly in logic; the randomizer provides 12 Ability Cells.",
            "Charge Flame Burn is in logic for some plants; the randomizer provides 3 Ability Cells."
          ]
        },
        {
          "text": "Legends tell of a path set called 'insane', so heinous it was banished from all presets. If you don't value your sanity or your time, some say you can turn those paths on from the Logic Paths tab.",
          "category": "Logic",
          "importance": "major"
        }
      ]
    }
  ]
}
